export const CHANGE_TYPE_TO_UI_TEXT = {
    classification: "Classification change",
    dependency: "Dependency change",
    format: "Format change",
    functionality: "Functionality change",
    entropy: "Entropy change",
    hash: "Content change",
    indicator: "Behavior change",
    name: "Name change",
    policy: "Issue change",
    size: "Size change",
    tag: "Tag change",
    toolchain: "Toolchain change",
    vulnerability: "Vulnerability change",
    action: "Action change",
    uri: "URI change",
};
//# sourceMappingURL=constants.js.map